import React, {Component, useState, useEffect} from 'react';

import {Route, Switch, Redirect} from 'react-router-dom';

import Home from './pages/Home';
import ConnectHelp from './pages/ConnectHelp';
import DownloadConfig from './pages/DownloadConfig';
import ChargePlan from './pages/ChargePlan';
import PayHistory from './pages/PayHistory';
import dal from './data/DAL';
import QuestionRecord from './pages/QuestionRecord';
import AddQuestion from './pages/AddQuestion';
import QuestionDetail from './pages/QuestionDetail';
import ReplyQuestion from './pages/ReplyQuestion';

let packageJson = require('../package.json')
let debug = require('debug')('APP:App')
require('debug').enable('APP*')

debug("APP Version: " + packageJson.version)

function PrivateRoute({ component, ...rest }: any) {
    return (
        <Route
            {...rest}
            render={props =>
                dal.isUserRegistered? (
                    React.createElement(component, props)
                ) : (
                    <Redirect
                        to={{
                            pathname: "/home",
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
}

const App: React.FC = (props: any) => {
    return (
        <div>
            <Switch>
                <Route path="/home" component={Home}/>
                <PrivateRoute path="/connect-help" component={ConnectHelp}/>
                <PrivateRoute path="/download-config" component={DownloadConfig}/>
                <PrivateRoute path="/charge-plan" component={ChargePlan}/>
                <PrivateRoute path="/pay-history" component={PayHistory}/>
                <PrivateRoute path="/question-list" component={QuestionRecord}/>
                <PrivateRoute path="/add-question" component={AddQuestion}/>
                <PrivateRoute path="/question-detail" component={QuestionDetail}/>
                <PrivateRoute path="/reply-question" component={ReplyQuestion}/>
            </Switch>
        </div>
    );
};

export default App;
